export const statusList = [
    {value: 'backlog', label: 'Backlog'},
    {value: 'concluido', label: 'Concluído'},
    {value: 'doing', label: 'Doing'},
    {value: 'negado', label: 'Negado'},
    {value: 'pendente', label: 'Pendente'},
    {value: 'travado', label: 'Travado'},
]